import { render } from "./QueueScreen.vue?vue&type=template&id=da7f3680&scoped=true"
import script from "./QueueScreen.vue?vue&type=script&lang=js"
export * from "./QueueScreen.vue?vue&type=script&lang=js"

import "./QueueScreen.vue?vue&type=style&index=0&id=da7f3680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7f3680"]])

export default __exports__